import React, { useState, useRef, useEffect } from 'react';
import Draggable from 'react-draggable';

const ChatPopout = ({ messages, message, setMessage, onSendMessage, nickname, socketRef, roomId }) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const messagesEndRef = useRef(null);
  const [position, setPosition] = useState({ x: window.innerWidth - 350, y: 100 });

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const handleDrag = (e, data) => {
    setPosition({ x: data.x, y: data.y });
  };

  return (
    <Draggable
      handle=".popout-header"
      position={position}
      onDrag={handleDrag}
      bounds="parent"
    >
      <div className={`chat-popout-container ${isMinimized ? 'minimized' : ''}`}>
        <div className="popout-header">
          <div className="popout-title">
            <span>💬 Chat</span>
          </div>
          <div className="popout-actions">
            <button 
              className="popout-action-btn" 
              onClick={() => setIsMinimized(!isMinimized)}
              title={isMinimized ? 'Maximize' : 'Minimize'}
            >
              {isMinimized ? '⬜' : '➖'}
            </button>
          </div>
        </div>
        
        {!isMinimized && (
          <>
            <div className="popout-messages">
              {messages.length === 0 ? (
                <div className="no-messages">
                  <p>No messages yet</p>
                </div>
              ) : (
                messages.map((msg, index) => (
                  <div key={index} className={`chat-message ${msg.userId === socketRef.current?.id ? 'own' : 'other'}`}>
                    <div className="message-header">
                      <span className="sender-name">{msg.nickname}</span>
                      <span className="message-time">{formatTime(msg.timestamp)}</span>
                    </div>
                    <div className="message-content">{msg.message}</div>
                  </div>
                ))
              )}
              <div ref={messagesEndRef} />
            </div>
            
            <div className="popout-input-container">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Type a message..."
                maxLength={1000}
                className="popout-input"
              />
              <button 
                onClick={onSendMessage}
                className="popout-send-btn"
                disabled={!message.trim()}
                title="Send"
              >
                ➤
              </button>
            </div>
          </>
        )}
      </div>
    </Draggable>
  );
};

export default ChatPopout;


